import React from 'react';
import './Card.css';

/**
 * Card Component
 * Container component with optional header, icon, and footer
 * 
 * @param {string} title - Card title (optional)
 * @param {string} icon - FontAwesome icon for header
 * @param {ReactNode} children - Card content
 * @param {ReactNode} footer - Footer content (optional)
 * @param {string} variant - 'glass', 'solid', 'bordered'
 * @param {boolean} clickable - Makes card clickable
 * @param {function} onClick - Click handler for clickable cards
 * @param {boolean} compact - Reduces padding
 * @param {string} className - Additional CSS classes
 */
const Card = ({
  title,
  icon,
  children,
  footer,
  variant = 'glass',
  clickable = false,
  onClick,
  compact = false,
  className = ''
}) => {
  const cardClasses = [
    'card',
    `card-${variant}`,
    clickable && 'card-clickable',
    compact && 'card-compact',
    className
  ].filter(Boolean).join(' ');

  const hasHeader = title || icon;

  return (
    <div className={cardClasses} onClick={clickable ? onClick : undefined}>
      {hasHeader && (
        <div className="card-header">
          {icon && <i className={`fas ${icon} card-icon`}></i>}
          {title && <h3 className="card-title">{title}</h3>}
        </div>
      )}
      <div className="card-body">
        {children}
      </div>
      {footer && (
        <div className="card-footer">
          {footer}
        </div>
      )}
    </div>
  );
};

export default Card;